/* SIDONIA · «Hacer una oferta» (snippets/sidonia-offer.liquid).
 *
 * - Abre la ventana con cualquier botón data-sidonia-offer-open, y sola al volver del inicio de sesión (?oferta=1) o
 *   tras un envío normal del formulario (contact_posted=true).
 * - Sin sesión (cuando se pide): se escribe la oferta, «Continuar» la guarda como borrador en el navegador y lleva a
 *   entrar con el email; al volver, la ventana se abre con la oferta puesta. snippets/sidonia-offer-resume.liquid
 *   recuerda el borrador en el resto de la tienda («Terminar tu oferta»).
 * - Envía la oferta al servidor de ofertas, que manda al cliente el email de gracias y avisa al equipo:
 *     POST {servidor} JSON { handle, titulo, url, precio, oferta, nombre, email, telefono, mensaje, contexto,
 *                            cliente: { id, ts, firma } }  →  { ok: true, email_enviado: true|false }
 *   Si no hay servidor o falla, se envía de forma normal el formulario de contacto de Shopify (llega al correo de la
 *   tienda). Normal y no por detrás: el captcha invisible de Shopify (hCaptcha) solo añade su ficha a los envíos
 *   normales. La página se recarga y la ventana enseña el «gracias» (form.posted_successfully?).
 * - Recuerda en este navegador la última oferta por cada anuncio, para enseñarla al volver.
 */
(() => {
  if (window.SidoniaOffer) return;
  window.SidoniaOffer = true;

  const eur = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
  const fmt = (n) => eur.format(Math.round(n));
  const KEY = 'sidonia-ofertas';
  const DRAFT = 'sidonia-oferta-borrador';
  const DRAFT_HOURS = 6;
  const draft = {
    get(handle) {
      try {
        const d = JSON.parse(localStorage.getItem(DRAFT));
        return d && d.handle === handle && Date.now() - d.t < DRAFT_HOURS * 3600e3 ? d : null;
      } catch (e) { return null; }
    },
    set(d) { try { localStorage.setItem(DRAFT, JSON.stringify({ ...d, t: Date.now() })); } catch (e) { /* sin almacenamiento */ } },
    clear() { try { localStorage.removeItem(DRAFT); } catch (e) { /* sin almacenamiento */ } }
  };
  const store = {
    all() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
    save(handle, data) { try { const a = this.all(); a[handle] = data; localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) { /* sin almacenamiento */ } }
  };

  function init() {
    const dlg = document.querySelector('[data-sidonia-offer]');
    if (!dlg) return;
    const d = dlg.dataset;
    const form = document.getElementById(d.form);
    const amount = dlg.querySelector('[data-so-amount]');
    const hint = dlg.querySelector('[data-so-hint]');
    const msg = dlg.querySelector('[data-so-msg]');
    const submit = dlg.querySelector('[data-so-submit]');
    const price = Number(d.price) || 0;

    const value = () => Number((amount?.value || '').replace(/[^\d]/g, '')) || 0;
    const body = dlg.querySelector('[data-so-body]');
    const setAmount = (n) => { if (amount && n) { amount.value = Math.round(n).toLocaleString('es-ES'); amount.dispatchEvent(new Event('input')); } };
    const pane = (name) => dlg.querySelectorAll('[data-so-pane]').forEach((p) => { p.hidden = p.dataset.soPane !== name; });
    const say = (t) => { if (msg) { msg.textContent = t; msg.hidden = !t; } };

    const last = () => {
      const box = dlg.querySelector('[data-so-last]');
      const prev = store.all()[d.handle];
      if (!box || !prev) return;
      const when = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'long' }).format(new Date(prev.t));
      box.textContent = `Ya ofreciste ${fmt(prev.oferta)} el ${when}. Puedes enviar otra si quieres.`;
      box.hidden = false;
    };

    const open = () => {
      if (!dlg.open) dlg.showModal();
      if (!dlg.querySelector('[data-so-pane="done"]').hidden) return;
      last();
      say('');
      if (amount && window.matchMedia('(pointer: fine)').matches) setTimeout(() => amount.focus(), 50);
    };

    const done = (email, mailed, enChat) => {
      const t = dlg.querySelector('[data-so-done-text]');
      const m = dlg.querySelector('[data-so-done-mail]');
      const v = value();
      // De la comunidad: se la mandamos al dueño, que contesta directamente
      if (t && v) t.textContent = d.seller ? (enChat ? `Tu oferta de ${fmt(v)} ya está en el chat con ${d.seller}. Te avisamos por email cuando conteste; la conversación sigue en Mi perfil › Mensajes.` : `Le hemos enviado tu oferta de ${fmt(v)} a ${d.seller}. Te contestará directamente a tu email o teléfono.`) : `Hemos recibido tu oferta de ${fmt(v)} por ${d.title}. Te responderemos lo antes posible.`;
      // Desde el chat se sigue hablando: un botón para abrirlo
      const ya = dlg.querySelector('[data-so-chat]');
      if (ya) ya.remove();
      if (enChat && t && window.sidoniaChat) {
        const b = document.createElement('button');
        b.type = 'button'; b.dataset.soChat = '1'; b.className = 'so__chat'; b.textContent = 'Abrir el chat';
        b.style.cssText = 'margin-top:12px;min-height:44px;padding:0 20px;border:0;border-radius:999px;background:#1a1a1a;color:#fff;font:inherit;font-weight:700;cursor:pointer';
        const btn = document.querySelector('[data-sidonia-chat][data-tipo="venta"]');
        b.addEventListener('click', () => { dlg.close(); if (btn) btn.click(); });
        t.after(b);
      }
      if (m) {
        m.hidden = !(mailed && email);
        if (mailed && email) m.textContent = `Te hemos enviado un email con el resumen a ${email}.`;
      }
      if (v) store.save(d.handle, { oferta: v, t: Date.now() });
      draft.clear();
      const welcome = dlg.querySelector('[data-so-welcome]');
      if (welcome) welcome.hidden = true;
      pane('done');
      if (!dlg.open) dlg.showModal();
      document.dispatchEvent(new CustomEvent('sidonia:oferta', { detail: { handle: d.handle, oferta: v } }));
    };

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-sidonia-offer-open]')) { e.preventDefault(); open(); }
    });
    dlg.querySelectorAll('[data-so-close]').forEach((b) => b.addEventListener('click', () => dlg.close()));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });

    amount?.addEventListener('input', () => {
      amount.value = amount.value.replace(/[^\d]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const v = value();
      if (v) say('');
      let h = '';
      if (price && v) {
        const pct = Math.round((v / price) * 100);
        if (v >= price) h = 'Es el precio publicado o más: te llamamos enseguida.';
        else if (pct < 60) h = `Es un ${100 - pct} % menos que el precio publicado. Las ofertas tan bajas rara vez se aceptan, pero se la pasamos.`;
        else h = `Un ${100 - pct} % menos que el precio publicado.`;
      }
      if (hint) hint.textContent = h;
    });

    // Sin sesión: guardar la oferta y entrar con el email; al volver, la ventana se abre con todo puesto
    dlg.querySelector('[data-so-continue]')?.addEventListener('click', () => {
      const v = value();
      if (!v) { say('Escribe cuánto ofreces.'); amount?.focus(); return; }
      draft.set({ handle: d.handle, titulo: d.title, path: location.pathname, oferta: v, mensaje: body?.value.trim() || '' });
      const go = dlg.querySelector('[data-so-login-form]').dataset.loginUrl;
      const btn = dlg.querySelector('[data-so-continue]');
      // La ventana de «Únete a Sidonia» (layout/theme.liquid); si no está, directo al acceso
      if (window.sidoniaLogin) { dlg.close?.(); window.sidoniaLogin(location.pathname + location.search, 'Tu oferta ya está escrita y guardada: entra y se la mandamos al vendedor.', 'oferta'); return; }
      btn.disabled = true;
      btn.textContent = 'Un momento…';
      location.href = go;
    });

    const get = (n) => form?.querySelector(`[name="contact[${n}]"]`)?.value.trim() || '';

    // Campos ocultos del correo a la tienda: la oferta y un resumen en el cuerpo (nunca vacío)
    const fill = (v) => {
      form.querySelector('[data-so-offer-field]').value = fmt(v);
      const resumen = [`Oferta de ${fmt(v)} por ${d.title}`, price ? `(${d.context === 'subasta' ? 'puja más alta' : 'precio publicado'}: ${fmt(price)})` : '', d.url].filter(Boolean).join(' ');
      const msg = get('Mensaje');
      form.querySelector('[data-so-body-field]').value = msg ? `${resumen}\n\nMensaje: ${msg}` : resumen;
    };

    // Mientras Shopify recibe la oferta (la página se recarga al terminar)
    const sending = () => {
      const t = document.createElement('div');
      t.className = 'so-sending';
      t.setAttribute('role', 'status');
      t.textContent = 'Enviando tu oferta…';
      document.body.append(t);
    };

    // Envío normal del formulario de Shopify: así su captcha invisible (hCaptcha) añade su ficha antes de enviarlo
    // (un envío por detrás, sin ficha, Shopify lo rechaza con «Missing CAPTCHA token»). Se cierra la ventana por si
    // Shopify tiene que enseñar su verificación, y la oferta se guarda para el «gracias» de la vuelta.
    const sendToShopify = (v) => {
      store.save(d.handle, { oferta: v, t: Date.now() });
      draft.set({ handle: d.handle, titulo: d.title, path: location.pathname, oferta: v, mensaje: get('Mensaje') });
      if (dlg.open) dlg.close();
      sending();
      if (form.requestSubmit) form.requestSubmit();
      else {
        const b = document.createElement('button');
        b.type = 'submit';
        b.hidden = true;
        form.append(b);
        b.click();
      }
    };

    submit?.addEventListener('click', async () => {
      const v = value();
      if (!v) { say('Escribe cuánto ofreces.'); amount?.focus(); return; }
      if (!form.reportValidity()) return;
      fill(v);
      say('');
      const email = get('email');

      // 1. Servidor de ofertas (email de gracias al cliente y aviso al equipo)
      if (d.endpoint && window.fetch) {
        submit.disabled = true;
        const label = submit.textContent;
        submit.textContent = 'Enviando…';
        try {
          const r = await fetch(d.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              handle: d.handle, titulo: d.title, url: d.url, precio: price, oferta: v, contexto: d.context, imagen: d.image || '',
              nombre: get('name'), email, telefono: get('phone'), mensaje: get('Mensaje'),
              cliente: d.customer ? { id: d.customer, ts: d.ts, firma: d.sig } : null
            })
          });
          const data = await r.json().catch(() => ({}));
          submit.disabled = false;
          submit.textContent = label;
          if (r.ok && data.ok) { done(email, Boolean(data.email_enviado), Boolean(data.en_chat)); return; }
        } catch (err) {
          submit.disabled = false;
          submit.textContent = label;
        }
      }

      // 2. Formulario de contacto de Shopify (llega al correo de la tienda)
      sendToShopify(v);
    });

    // En cualquier envío normal del formulario, la oferta siempre va puesta (sin bloquearlo: Shopify añade su captcha)
    form?.addEventListener('submit', () => {
      const v = value();
      if (v) fill(v);
    });

    // Abrir sola: al volver de iniciar sesión, o tras un envío normal que ha salido bien
    const params = new URLSearchParams(location.search);
    const clean = (...keys) => {
      if (!keys.some((k) => params.has(k))) return;
      keys.forEach((k) => params.delete(k));
      const q = params.toString();
      history.replaceState(history.state, '', location.pathname + (q ? `?${q}` : '') + location.hash);
    };
    if (dlg.querySelector('[data-so-posted]')) {
      const prev = store.all()[d.handle];
      if (prev && amount) amount.value = Math.round(prev.oferta).toLocaleString('es-ES');
      done('', false);
      clean('contact_posted');
    } else if (dlg.querySelector('[data-so-errors]')) {
      // Shopify ha devuelto algún error: la ventana vuelve a abrirse con la oferta puesta y el aviso
      const saved = draft.get(d.handle);
      if (saved) { setAmount(saved.oferta); if (body && saved.mensaje && !body.value) body.value = saved.mensaje; }
      open();
    } else {
      // Oferta guardada antes de entrar (o a medias): se recupera
      const saved = draft.get(d.handle);
      if (saved) {
        setAmount(saved.oferta);
        if (body && saved.mensaje && !body.value) body.value = saved.mensaje;
      }
      if (params.get('oferta') === '1' || (saved && form && d.customer)) {
        const welcome = dlg.querySelector('[data-so-welcome]');
        if (welcome && saved && d.customer) welcome.hidden = false;
        open();
      }
      clean('oferta');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
